module.exports = __webpack_public_path__ + "img/DNR-IL-FinalColors.15e56fa3.png";